import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SentryCloudSearchService = {
  citiesSearch: () => axios.post(API_URL + `/sentryCloudSearch/citiesSearch`).then(({ data }) => data.data).catch((err) => { throw err }),
  interligationCreate: (payload) => axios.post(API_URL + `/sentryCloudSearch/interligationCreate`, payload).then(({ data }) => data.data).catch((err) => { throw err }),
  interligationResult: (id) => axios.get(API_URL + `/sentryCloudSearch/interligationResult/${id}`).then(({ data }) => data.data).catch((err) => { throw err }),
  lastSearch: () => axios.post(API_URL + `/sentryCloudSearch/lastSearch`).then(({ data }) => data.data).catch((err) => { throw err }),
};

export default SentryCloudSearchService;